import scriberImage from "./monsters/scriber h300.png";
import chortImage from "./monsters/chort h300.png";
import abishaiImage from "./monsters/abishai h300.png";
import sanguineDryadImage from "./monsters/sanguine dryad h300.png";
import dryadImage from "./monsters/dryad h300.png";
import savanImage from "./monsters/savan h300.png";
import garundImage from "./monsters/garund h300.png";
import hellHoundImage from "./monsters/hell hound h300.png";

export const monsterAssets = {
  scriber: {
    path: scriberImage,
    alt: "Scribe devil from Tome of Beasts 2 by Kobold Press",
  },
  chort: {
    path: chortImage,
    alt: "Chort devil from Tome of Beasts by Kobold Press",
  },
  abishai: {
    path: abishaiImage,
    alt: "Abishai from Monster Manual",
  },
  sanguine_dryad: {
    path: sanguineDryadImage,
    alt: "Corrupted dryad by Linda Lithén @lindalithen",
  },
  dryad: {
    path: dryadImage,
    alt: "Nature Godlike by @telthona",
  },
  savan: {
    path: savanImage,
    alt: "Tiefling by unknown artist",
  },
  garund: {
    path: garundImage,
    alt: "Hobgoblin rogue by Phill Berry @phill_art",
  },
  hell_hound: {
    path: hellHoundImage,
    alt: "Netherworld Fortress by Michelle (Hardy) Martinez",
  },
};
